import { render, staticRenderFns } from "./SearchModalEvents.vue?vue&type=template&id=64a1bd9d&scoped=true&"
import script from "./SearchModalEvents.vue?vue&type=script&lang=js&"
export * from "./SearchModalEvents.vue?vue&type=script&lang=js&"
import style0 from "./SearchModalEvents.vue?vue&type=style&index=0&id=64a1bd9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1bd9d",
  null
  
)

export default component.exports